import React from 'react';
import { motion } from 'framer-motion';
import { Smile, Moon, Brain, Heart, Users, Sparkles } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    text: 'Menos ansiedad',
    icon: <Smile size={24} data-id="element-14" />,
    color: 'bg-pastel-pink text-pink-700'
  }, {
    text: 'Más calma',
    icon: <Sparkles size={24} data-id="element-15" />,
    color: 'bg-pastel-lavender text-purple-700'
  }, {
    text: 'Mejor descanso',
    icon: <Moon size={24} data-id="element-16" />,
    color: 'bg-pastel-lavender-dark text-white'
  }, {
    text: 'Mayor concentración',
    icon: <Brain size={24} data-id="element-17" />,
    color: 'bg-pastel-aqua text-teal-800'
  }, {
    text: 'Reduce tiempo en pantallas',
    icon: <div size={24} data-id="element-18" />,
    color: 'bg-pastel-yellow text-amber-800'
  }, {
    text: 'Fortalece autoestima',
    icon: <Heart size={24} data-id="element-19" />,
    color: 'bg-rose-200 text-rose-700'
  }, {
    text: 'Mejora vínculo familiar',
    icon: <Users size={24} data-id="element-20" />,
    color: 'bg-pastel-mint text-emerald-800'
  }];
  return <section className="py-20 bg-white" data-id="element-21">
      <div className="container mx-auto px-5 sm:px-8 lg:px-12" data-id="element-22">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4" data-id="element-24">
            Beneficios para toda la vida
          </h2>
        </div>

        <div className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto" data-id="element-25">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-center gap-3 bg-pastel-white border border-gray-100 rounded-full pr-6 pl-2 py-2 shadow-sm hover:shadow-md transition-shadow" data-id="element-26">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${benefit.color}`} data-id="element-27">
                {benefit.icon}
              </div>
              <span className="font-bold text-gray-700" data-id="element-28">{benefit.text}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}